const Logout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("IsLogged");
    window.location.replace("/");
}

export default Logout;